import React from 'react';
import OrderListPage from './OrderListPage';

interface IProps {
  handleModalOpen: (data: any) => void;
  rowDetails: any;
  setRowDetails: any;
  orderCounts?: { [key: string]: number };
}

const Dashboard = (props: IProps) => (
  <OrderListPage
    section="Search"
    showKpis
    emptyMessage="No orders match these filters."
    {...props}
  />
);

export default Dashboard;
